import React from 'react';
// Đừng quên thêm dòng này ở đầu file App.js của bạn:
import './App.css';

// Dữ liệu mẫu - Trong thực tế, dữ liệu này sẽ được lấy từ API hoặc hệ thống quản trị nội dung (CMS)
const courses = [
  {
    title: "Toán Nền Tảng Lớp 6-9",
    description: "Xây dựng lại gốc kiến thức, tạo nền tảng vững chắc và khơi dậy niềm yêu thích Toán học.",
    image: "https://placehold.co/600x400/34495e/ffffff?text=Toan+Nen+Tang",
  },
  {
    title: "Luyện Thi Vào 10 Chuyên",
    description: "Chương trình nâng cao, bứt phá điểm số với các dạng bài chuyên sâu và chiến thuật làm bài hiệu quả.",
    image: "https://placehold.co/600x400/f1c40f/000000?text=Luyen+Thi+10",
  },
  {
    title: "Toán Tư Duy Tiểu Học",
    description: "Phát triển tư duy logic, khả năng giải quyết vấn đề cho học sinh từ lớp 1 đến lớp 5.",
    image: "https://placehold.co/600x400/3498db/ffffff?text=Toan+Tieu+Hoc",
  },
];

const testimonials = [
  {
    quote: "Con tôi từ một học sinh sợ Toán giờ đã tự tin hơn rất nhiều. Cảm ơn các thầy cô Talent Math.",
    name: "Chị Minh Anh",
    role: "Phụ huynh học sinh lớp 7",
  },
  {
    quote: "Phương pháp dạy ở đây rất dễ hiểu, các thầy cô luôn tạo không khí vui vẻ, không áp lực.",
    name: "Em Gia Bảo",
    role: "Học sinh lớp 9",
  },
  {
    quote: "Nhờ trung tâm mà em đã đạt được mục tiêu vào trường chuyên. Lời giải của các thầy cô rất chi tiết.",
    name: "Em Tuệ Nhi",
    role: "Cựu học sinh",
  },
];

const quizData = {
  title: "Kiểm tra nhanh kiến thức Hình học Lớp 8",
  questions: [
    {
      question: "Tứ giác có bốn cạnh bằng nhau là hình gì?",
      options: ["Hình chữ nhật", "Hình thoi", "Hình bình hành", "Hình thang cân"],
      correctAnswer: "Hình thoi",
    },
    {
      question: "Tổng số đo bốn góc của một tứ giác bằng bao nhiêu?",
      options: ["180 độ", "270 độ", "360 độ", "540 độ"],
      correctAnswer: "360 độ",
    },
    {
      question: "Hình thang có hai đường chéo bằng nhau là hình gì?",
      options: ["Hình thang vuông", "Hình thang cân", "Hình bình hành", "Hình thoi"],
      correctAnswer: "Hình thang cân",
    },
  ],
};


// Các biểu tượng (Icons) - Sử dụng SVG để không phụ thuộc vào thư viện ngoài
const MenuIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>
  </svg>
);

const XIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const BookOpenIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
    </svg>
);

const TargetIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>
    </svg>
);

const UsersIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
);


// Component Header
const Header = ({ setView, activeView }) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const navItems = [
    { id: 'home', label: 'Trang Chủ' },
    { id: 'about', label: 'Giới Thiệu' },
    { id: 'courses', label: 'Khóa Học' },
    { id: 'quiz', label: 'Luyện Tập' },
    { id: 'contact', label: 'Liên Hệ' },
  ];

  const NavLink = ({ id, label }) => (
    <button 
      onClick={() => { setView(id); setIsMenuOpen(false); }}
      className={`nav-link ${activeView === id ? 'active' : ''}`}
    >
      {label}
    </button>
  );

  return (
    <header className="header">
      <div className="container header-content">
        <div className="header-brand">
            <button onClick={() => setView('home')} className="logo">
              Talent<span className="logo-highlight">Math</span>
            </button>
        </div>
        <nav className="header-nav-desktop">
            {navItems.map(item => <NavLink key={item.id} {...item} />)}
        </nav>
        <div className="header-cta-desktop">
            <button onClick={() => setView('contact')} className="btn btn-primary">
                Đăng Ký Học Thử
            </button>
        </div>
        <div className="header-menu-mobile">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="menu-toggle"
            >
              {isMenuOpen ? <XIcon height="24" width="24" /> : <MenuIcon height="24" width="24" />}
            </button>
        </div>
      </div>
      {isMenuOpen && (
        <div className="mobile-nav">
          <nav className="mobile-nav-links">
             {navItems.map(item => <NavLink key={item.id} {...item} />)}
          </nav>
          <div className="mobile-nav-cta">
             <button onClick={() => setView('contact')} className="btn btn-primary">
                Đăng Ký Học Thử
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

// Component Hero Section
const HeroSection = ({ setView }) => (
  <section className="hero-section">
    <div className="container hero-content">
      <h1 className="hero-title">
        <span className="hero-title-line1">Ươm mầm</span>
        <span className="hero-title-line2">Tài Năng Toán Học</span>
      </h1>
      <p className="hero-subtitle">
        Phương pháp giảng dạy đột phá, giúp học sinh không chỉ giỏi Toán mà còn vững tư duy, tự tin chinh phục mọi kỳ thi.
      </p>
      <div className="hero-actions">
        <button onClick={() => setView('courses')} className="btn btn-primary">
          Xem Các Khóa Học
        </button>
        <button onClick={() => setView('quiz')} className="btn btn-secondary">
          Làm Bài Test Nhanh
        </button>
      </div>
    </div>
  </section>
);

// Component About Section
const AboutSection = () => (
    <section id="about" className="section-padding bg-white">
        <div className="container">
            <div className="section-header">
                <h2 className="section-tagline">Về Talent Math</h2>
                <p className="section-title">Tại Sao Nên Chọn Chúng Tôi?</p>
                <p className="section-subtitle">
                    Chúng tôi không chỉ dạy kiến thức, chúng tôi xây dựng nền tảng tư duy và truyền cảm hứng học tập cho từng học sinh.
                </p>
            </div>
            <div className="features-grid">
                <div className="feature-card">
                    <span className="feature-icon-wrapper">
                        <BookOpenIcon height="24" width="24" />
                    </span>
                    <h3 className="feature-title">Phương Pháp Độc Quyền</h3>
                    <p className="feature-description">
                        Tiếp cận bài giảng trực quan, dễ hiểu, tập trung vào bản chất vấn đề thay vì học vẹt, học thuộc.
                    </p>
                </div>
                <div className="feature-card">
                    <span className="feature-icon-wrapper">
                        <TargetIcon height="24" width="24" />
                    </span>
                    <h3 className="feature-title">Lộ Trình Cá Nhân Hóa</h3>
                    <p className="feature-description">
                        Đánh giá năng lực đầu vào và thiết kế lộ trình học tập riêng, phù hợp với mục tiêu và năng lực của từng em.
                    </p>
                </div>
                <div className="feature-card">
                     <span className="feature-icon-wrapper">
                        <UsersIcon height="24" width="24" />
                    </span>
                    <h3 className="feature-title">Đội Ngũ Giáo Viên Tâm Huyết</h3>
                    <p className="feature-description">
                        100% giáo viên giỏi chuyên môn, giàu kinh nghiệm và luôn sẵn sàng hỗ trợ học sinh 24/7.
                    </p>
                </div>
            </div>
        </div>
    </section>
);

// Component Courses Section
const CoursesSection = () => (
  <section id="courses" className="section-padding bg-light">
    <div className="container">
      <div className="section-header">
        <h2 className="section-title">Các Khóa Học Nổi Bật</h2>
        <p className="section-subtitle">Tìm kiếm khóa học phù hợp nhất với nhu cầu và mục tiêu của bạn.</p>
      </div>
      <div className="courses-grid">
        {courses.map((course) => (
          <div key={course.title} className="course-card">
            <img className="course-card-image" src={course.image} alt={course.title} />
            <div className="course-card-content">
              <h3 className="course-card-title">{course.title}</h3>
              <p className="course-card-description">{course.description}</p>
              <div className="course-card-action">
                <a href="#contact" className="btn btn-dark">
                  Xem Chi Tiết
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// Component Quiz View
const QuizView = () => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = React.useState(0);
  const [selectedAnswers, setSelectedAnswers] = React.useState({});
  const [showResult, setShowResult] = React.useState(false);
  const [score, setScore] = React.useState(0);

  const handleAnswerSelect = (questionIndex, answer) => {
    setSelectedAnswers({
      ...selectedAnswers,
      [questionIndex]: answer,
    });
  };

  const handleSubmit = () => {
    let newScore = 0;
    quizData.questions.forEach((q, index) => {
      if (selectedAnswers[index] === q.correctAnswer) {
        newScore++;
      }
    });
    setScore(newScore);
    setShowResult(true);
  };
  
  const handleRestart = () => {
      setCurrentQuestionIndex(0);
      setSelectedAnswers({});
      setShowResult(false);
      setScore(0);
  }

  if (showResult) {
    return (
      <section className="section-padding bg-white">
        <div className="quiz-container">
          <div className="quiz-result-box">
            <h2 className="quiz-result-title">Kết quả</h2>
            <p className="quiz-result-score">
              {score} / {quizData.questions.length}
            </p>
            <p className="quiz-result-subtitle">
              Bạn đã trả lời đúng {score} câu hỏi!
            </p>
             <button onClick={handleRestart} className="btn btn-primary">
                Làm lại
            </button>
          </div>
          
          <div className="quiz-review">
            {quizData.questions.map((q, index) => {
                const isCorrect = selectedAnswers[index] === q.correctAnswer;
                return (
                    <div key={index} className={`review-item ${isCorrect ? 'correct' : 'incorrect'}`}>
                        <p className="review-question">Câu {index + 1}: {q.question}</p>
                        <p className="review-user-answer">Đáp án của bạn: <span>{selectedAnswers[index] || "Chưa trả lời"}</span></p>
                        <p className={`review-correct-answer`}>
                            Đáp án đúng: {q.correctAnswer}
                        </p>
                    </div>
                )
            })}
          </div>
        </div>
      </section>
    );
  }

  const currentQuestion = quizData.questions[currentQuestionIndex];

  return (
    <section className="section-padding bg-light">
      <div className="quiz-container">
        <div className="quiz-box">
          <h2 className="quiz-title">{quizData.title}</h2>
          <div className="quiz-progress">
            Câu hỏi {currentQuestionIndex + 1} / {quizData.questions.length}
          </div>
          
          <div className="quiz-question-area">
            <p className="quiz-question-text">{currentQuestion.question}</p>
            <div className="quiz-options">
              {currentQuestion.options.map((option) => (
                <button
                  key={option}
                  onClick={() => handleAnswerSelect(currentQuestionIndex, option)}
                  className={`quiz-option-btn ${selectedAnswers[currentQuestionIndex] === option ? 'selected' : ''}`}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>
          
          <div className="quiz-navigation">
             {currentQuestionIndex < quizData.questions.length - 1 ? (
                <button onClick={() => setCurrentQuestionIndex(currentQuestionIndex + 1)} className="btn btn-dark">
                    Câu Tiếp Theo
                </button>
            ) : (
                <button onClick={handleSubmit} className="btn btn-success">
                    Nộp Bài
                </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};


// Component Testimonials Section
const TestimonialsSection = () => (
    <section className="section-padding bg-dark">
        <div className="container">
            <div className="section-header text-light">
                <h2 className="section-title">Học Viên & Phụ Huynh Nói Gì?</h2>
                <p className="section-subtitle">Niềm tin và sự tiến bộ của học sinh là động lực lớn nhất của chúng tôi.</p>
            </div>
            <div className="testimonials-grid">
                {testimonials.map((testimonial) => (
                    <div key={testimonial.name} className="testimonial-card">
                        <p className="testimonial-quote">"{testimonial.quote}"</p>
                        <div className="testimonial-author">
                            <p className="testimonial-name">{testimonial.name}</p>
                            <p className="testimonial-role">{testimonial.role}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);


// Component Contact Section
const ContactSection = () => (
    <section id="contact" className="section-padding bg-white">
        <div className="container contact-container">
            <div className="section-header">
                <h2 className="section-title">Liên Hệ & Đăng Ký</h2>
                <p className="section-subtitle">Để lại thông tin để được tư vấn lộ trình học miễn phí hoặc ghé thăm trung tâm của chúng tôi.</p>
            </div>
            <div className="contact-form-wrapper">
                <form action="#" method="POST" className="contact-form">
                    <div className="form-grid">
                        <div className="form-group">
                            <label htmlFor="parent-name">Họ tên Phụ huynh</label>
                            <input type="text" name="parent-name" id="parent-name" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="phone">Số điện thoại</label>
                            <input type="text" name="phone" id="phone" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="student-name">Họ tên Học sinh</label>
                            <input type="text" name="student-name" id="student-name" />
                        </div>
                        <div className="form-group">
                            <label htmlFor="student-grade">Lớp</label>
                            <input type="text" name="student-grade" id="student-grade" />
                        </div>
                        <div className="form-group full-width">
                             <label htmlFor="message">Nhu cầu tư vấn</label>
                             <textarea id="message" name="message" rows="4"></textarea>
                        </div>
                    </div>
                    <div className="form-actions">
                         <button type="submit" className="btn btn-primary">
                            Gửi Yêu Cầu
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </section>
);


// Component Footer
const Footer = ({ setView }) => (
  <footer className="footer">
    <div className="container footer-container">
      <div className="footer-grid">
        <div className="footer-brand">
           <button onClick={() => setView('home')} className="logo">
              Talent<span className="logo-highlight">Math</span>
            </button>
          <p className="footer-about">
            Nơi khơi nguồn tiềm năng toán học và xây dựng tương lai vững chắc cho thế hệ trẻ.
          </p>
        </div>
        <div className="footer-links-group">
          <div className="footer-links-column">
              <h3 className="footer-heading">Về chúng tôi</h3>
              <ul>
                <li><button onClick={() => setView('about')}>Giới thiệu</button></li>
                <li><button onClick={() => setView('courses')}>Khóa học</button></li>
              </ul>
          </div>
          <div className="footer-links-column">
              <h3 className="footer-heading">Hỗ trợ</h3>
              <ul>
                <li><button onClick={() => setView('quiz')}>Luyện tập</button></li>
                <li><button onClick={() => setView('contact')}>Liên hệ</button></li>
              </ul>
          </div>
           <div className="footer-links-column">
              <h3 className="footer-heading">Liên hệ</h3>
               <ul>
                  <li>Địa chỉ: Shophouse 19, Park 2, cc Euro Window, Đông Anh, Hà Nội</li>
                  <li>Điện thoại: 0968.42.01.09</li>
                  <li>Email: toan.talentmath@gmail.com</li>
              </ul>
            </div>
        </div>
      </div>
      <div className="footer-copyright">
        <p>&copy; 2025 Talent Math. All rights reserved.</p>
      </div>
    </div>
  </footer>
);


// Component chính của ứng dụng
export default function App() {
  const [view, setView] = React.useState('home');

  const renderContent = () => {
    switch (view) {
      case 'home':
        return (
          <>
            <HeroSection setView={setView} />
            <AboutSection />
            <CoursesSection />
            <TestimonialsSection />
            <ContactSection />
          </>
        );
      case 'about':
        return <AboutSection />;
      case 'courses':
        return <CoursesSection />;
      case 'quiz':
        return <QuizView />;
      case 'contact':
        return <ContactSection />;
      default:
        return <HeroSection setView={setView} />;
    }
  };

  return (
    <div id="app">
      <Header setView={setView} activeView={view} />
      <main>
        {renderContent()}
      </main>
      <Footer setView={setView} />
    </div>
  );
}
